import { publishMessage } from "../notification/notificationActions";
import * as fulfilmentLocationActionTypes from "./fulfilmentLocationTypes";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import Axios from "axios";
import { baseUrl, getCurrentUser } from "../../util/host";

export const setFulfilmentLocation = (fulfilmentLocation) => {
  return {
    type: fulfilmentLocationActionTypes.CREATE_FULFILMENT_LOCATION,
    value: fulfilmentLocation,
  };
};

export const setFulfilmentLocations = (fulfilmentLocations) => {
  return {
    type: fulfilmentLocationActionTypes.SET_Fulfilment_LOCATIONS,
    value: fulfilmentLocations,
  };
};

export const updateFulfilmentLocationSuccess = (fulfilmentLocation) => {
  return {
    type: fulfilmentLocationActionTypes.UPDATE_FULFILMENT_LOCATION,
    value: fulfilmentLocation,
  };
};

export const createFulfilmentLocation = (fulfilmentLocationData, onSuccess) => {
  const token = getCurrentUser()?.token || "";
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/fulfillment_location`,
      fulfilmentLocationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setFulfilmentLocation(res.data.data));
        dispatch(
          publishMessage({
            message: `Warehouse ID ${res.data.data.warehouse_id} created successfully and isSyncToInventory is ${res.data.data.is_sync_to_inventry}`,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const updateFulfilmentLocation = (id, fulfilmentLocationData, onSuccess) => {
  const token = getCurrentUser()?.token || "";
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.put(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/fulfillment_location/${id}`,
      fulfilmentLocationData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "non-dynamic-url": '/api/address/location/fulfillment_location/:id'
        },
      }
    )
      .then((res) => {
        dispatch(updateFulfilmentLocationSuccess(res.data.data));
        dispatch(
          publishMessage({
            message: `Warehouse ID ${fulfilmentLocationData.warehouseId} Fulfilment location updated successfully`,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};


export const getFulfilmentLocations = () => {
  const token = getCurrentUser()?.token || "";
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(
      `${baseUrl("REACT_APP_API_URL")}/api/address/location/fulfillment_location`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
            dispatch(setFulfilmentLocations(res.data.data));
            dispatch(hideSpinner());
          })
          .catch((err) => {
            console.log(err);
            dispatch(
              publishMessage({
                message: "Failed to fetch fulfilment locations",
                severity: "error",
              })
            );
            dispatch(hideSpinner());
          });
  };
};
